module.exports = __webpack_public_path__ + "img/interface OneB Player_2.6a453006.jpg";